<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-row>
        <v-col
          v-for="(engagement, index) in engagementPerCorporate"
          :key="index"
          cols="6"
          align="center"
          justify="center"
        >
          <v-card>
            <v-toolbar dark color="sleep">
              <v-toolbar-title> {{ engagement.cohort }} </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-spacer>
                <v-avatar color="secondary" class="white--text" size="100">
                  <h1>
                    {{ engagement.engagement[0].totalUserSample }}
                  </h1>
                </v-avatar>
              </v-spacer>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <highcharts v-if="engagementPerCorporate" :options="engagementPerCorporateReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { ENGAGEMENT_PER_CORP_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "CorporateEngagement",
  data() {
    return {
      engagementPerCorporate: null,
    };
  },
  computed: {
    engagementPerCorporateReport() {
      let series = this.engagementPerCorporate.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [
            c["actionDate"],
            parseInt((parseInt(c["userCount"]) / parseInt(c["totalUserSample"])) * 100),
          ]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Engagement per product",
        },
        xAxis: {
          categories: this.engagementPerCorporate[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "% engageed",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    engagementPerCorporate: {
      query: ENGAGEMENT_PER_CORP_QUERY,
    },
  },
};
</script>
